import { useMemo } from 'react';

import { INDICATOR_CLASS_NAMES, IndicatorClassNames } from './constants';

type IndicatorHook = IndicatorClassNames;

function useIndicator(isActive: boolean): IndicatorHook {
  const classNames: IndicatorClassNames = useMemo(
    () => ({
      container: `${INDICATOR_CLASS_NAMES.container} ${
        isActive
          ? 'border-purple-400 bg-purple-400'
          : 'border-neutral-300 bg-neutral-000'
      }`,
      tick: `${INDICATOR_CLASS_NAMES.tick} ${isActive ? 'block' : 'hidden'}`,
    }),
    [isActive],
  );

  return classNames;
}

export default useIndicator;
